import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    reorderUrl: String,
    paramName: { type: String, default: "ids" }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-sortable-handle]",
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: () => this.persistOrder()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async persistOrder() {
    const ids = [...this.element.querySelectorAll("[data-sortable-id]")].map(
      (el) => el.dataset.sortableId
    )
    const body = new URLSearchParams()
    ids.forEach((id) => body.append(`${this.paramNameValue}[]`, id))

    const token = document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
    const response = await fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token || ""
      },
      body,
      credentials: "same-origin"
    })

    if (!response.ok) return

    const html = await response.text()
    if (html) Turbo.renderStreamMessage(html)
  }
}
